import { ComponentProps } from "react";
import ChakraTabList from "@ui-kit/disclosure/TabList/TabList.web";
import ChakraTab from "@ui-kit/disclosure/Tab/Tab.web";
import BaseTabs from "@ui-kit/disclosure/BaseTabs/BaseTabs.web";

// Re-export the main Tabs component from BaseTabs (which is already a wrapper over Chakra)
export const Tabs = BaseTabs;

type TabListProps = ComponentProps<typeof ChakraTabList> & {
  bgColor?: string;
  border?: string;
};

export function TabList({ bgColor, border, ...props }: TabListProps) {
  return (
    <ChakraTabList
      zIndex="sticky"
      backgroundColor={bgColor ?? "white"}
      borderBottom={border ?? "1px solid"}
      borderColor="gray.400"
      paddingTop="sm"
      width="100%"
      height="element.4xl"
      outline="1px solid transparent"
      {...props}
    />
  );
}

type TabProps = ComponentProps<typeof ChakraTab>;

export function Tab(props: TabProps) {
  return (
    <ChakraTab
      borderRadius="xs"
      borderBottom="none"
      padding="none"
      css={{
        "&::before": {
          display: "none !important",
        },
        "& span": {
          paddingBottom: "12px",
          fontSize: "14px",
          borderBottom: "1px solid var(--chakra-colors-gray-400)",
        },
        // Support both data-selected (v3 tabs) and data-state for compatibility
        "&[data-selected] span, &[data-state=active] span": {
          color: "primary.700",
          borderBottom: "2px solid var(--chakra-colors-primary-700)",
        },
      }}
      {...props}
    />
  );
}
